import { TextField, RichTextField, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export type EventDetailResponse = {
  name: TextField;
  description: RichTextField;
  additionalResources: RichTextField;
  onlineEventSpecialInstructions: TextField;
  image: { jsonValue: ImageField };
  type: {
    targetItem: {
      eventType: TextField;
    };
  };
  host: {
    targetItem: {
      hostName: TextField;
      hostUrl: {
        jsonValue: LinkField;
      };
    };
  };
  inPersonEventLocation: {
    targetItem: EventLocation;
  };
  locationType: {
    targetItems: {
      id: string;
      name: string;
    }[];
  };
  onDemandVideo: {
    value: string;
  };
  onDemandVideoPlayerType: {
    targetItem: {
      playerID: {
        value: string;
      };
    };
  };
  onDemandSpecialInstructions: TextField;
  onDemandLinkButtonText: {
    value: string;
  };
  onDemandUrl: {
    jsonValue: LinkField;
  };
  children: {
    EventOccurrences: EventOccurrence[];
  };
};

export type EventLocation = {
  locationName: TextField;
  addressLine1: TextField;
  addressLine2: TextField;
  city: TextField;
  state: TextField;
  zipCode: TextField;
  directionsLink: {
    jsonValue: LinkField;
  };
};

export type EventOccurrence = {
  id: string;
  evolveEventID?: {
    value: string;
  };
  startDateTime: {
    jsonValue: {
      value: string;
    };
  };
  endDateTime: {
    jsonValue: {
      value: string;
    };
  };
  registerDeadlineDate: {
    jsonValue: {
      value: string;
    };
  };
  registerLinkButtonText: {
    value: string;
  };
  registerUrl: {
    jsonValue: LinkField;
  };
  isRegistrationForm: {
    boolValue: boolean;
  };
  canceled: {
    boolValue: boolean;
  };
  onlineEventUrl: {
    jsonValue: LinkField;
  };
  onlineEventLinkButtonText: {
    value: string;
  };
};
